import React, { useContext } from "react"
import VerticalLayout from "../VerticalLayout/index"
import TableListServices from "../TableList/TableListServices"
import { ServicesContext } from "./ServicesContext"

const Services = () => {
  const ServicesModel = useContext(ServicesContext)
  const { ServicesTableTitle, servicesData, getServiceList } = ServicesModel

  return (
    <VerticalLayout>
      <div style={{ marginTop: "70px" }}>
        <TableListServices
          createButton={true}
          title={"Services List"}
          edit={true}
          titleList={ServicesTableTitle?.titles}
          tableData={servicesData}
          edit={true}
          getServiceList={getServiceList}
          navLocation={"/details/serviceId?="}
        />
      </div>
    </VerticalLayout>
  )
}

export default Services
